const PATH_KEY = 'path';
const HANDOVER = 'handover/';
const HANDOVER_SUCCESS = 'handover/success/';
const HANDOVER_FAILED = 'handover/failed/';
const HANDOVER_CANCELLED = 'handover/cancelled/';

export function getBacklinkPathFromUrl(): string {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(PATH_KEY) || '';
}
export function setBacklinkPathToStorage(path: string): void {
    return sessionStorage.setItem(PATH_KEY, path);
}
export function removeBacklinkPathFromStorage(): void {
    return sessionStorage.removeItem(PATH_KEY);
}

function getHandoverStateUrl(): string | undefined {
    const hashParams = new URLSearchParams(window.location.hash?.substring(1) ?? '');
    const state = hashParams.get('state');
    if (!state || !state.startsWith(HANDOVER)) {
        return undefined;
    }
    return `#${decodeURIComponent(state)
        .replace(HANDOVER_SUCCESS, '')
        .replace(HANDOVER_FAILED, '')
        .replace(HANDOVER_CANCELLED, '')
        .replace(HANDOVER, '')}`;
}

export function getStoredBacklinkPathOrFromUrl(): string {
    const stateUrl = getHandoverStateUrl();

    if (stateUrl) {
        return stateUrl;
    }

    const storedPath = sessionStorage.getItem(PATH_KEY);

    if (storedPath) {
        return storedPath;
    }

    return getBacklinkPathFromUrl();
}
